<template>
  <div v-on="$listeners"
       :style="style">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'BaseNotification',
    inheritAttrs: false,
    data: function () {
      return {
        style: {
          position: 'fixed',
          width: '100%',
          zIndex: 9999,
        },
      };
    },
    created: function () {
      this.style = {
        ...this.style,
        ...this.$attrs,
      };
    },
  };
</script>
